<template>
  <div :class="`${openMenu ? '' : 'hidden'} justify-between items-center w-full lg:flex lg:w-auto lg:order-1`" id="mobile-menu-2">
    <ul class="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0">
      <li v-for="(item, index) in items" :key="index">
        <router-link
            :to="item.link"
            @click="openMenu = !openMenu"
            class="block uppercase py-2 pr-4 pl-3 text-lg rounded lg:bg-transparent hover:text-primary-800 text-primary-700 lg:p-0" aria-current="page"
        >
          {{ item.name }}
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'MenuHeader',
  data () {
    return {
      items: [
        {
          link: '/boutique',
          name: 'Boutique'
        },
        {
          link: '/histoire',
          name: 'Histoire'
        },
        {
          link: '/visite',
          name: 'Visite'
        }
      ],
      openMenu: false
    }
  },
  mounted () {
    this.emitter.on('open-menu', () => {
      this.openMenu = !this.openMenu
    })
  }
}
</script>

<style>
.router-link-exact-active {
  @apply text-primary-800 !important
}
</style>